// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#info-container{background-color:#FFFFFF;border-radius:6px;padding:40px 20px;height:max-content;overflow:auto;display:flex}@media (max-width: 767px){#info-container{padding:30px 10px}}\n", ""]);
// Exports
module.exports = exports;
